import React from 'react'
import { Navigate, useParams } from 'react-router'
import { useDisableAppHeaderSticky } from '@core/Areas/AppHeader/hooks/useDisableAppHeaderSticky'
import { MainContainer } from '@core/Components/Containers'
import { RacingSportsTabs } from './Components/RacingSportsTabs'
import { AccountActivityMain } from './Components/Main'
import type { Tabs } from './types'
import { ACCOUNT_ACTIVITY_ROUTE } from './constants'

const tabs: Tabs[] = ['pending', 'results', 'rebet', 'transactions']

/** MOBI Only */
export const AccountActivity: React.FC = () => {
  const { tab = 'pending' } = useParams<{ tab: Tabs }>()

  useDisableAppHeaderSticky()

  if (!tabs.includes(tab)) {
    return <Navigate to={`/${ACCOUNT_ACTIVITY_ROUTE}/${tabs[0]}`} />
  }

  return (
    <MainContainer background='surface300'>
      <RacingSportsTabs isRacing activeTab={tab} />

      <AccountActivityMain activeTab={tab} />
    </MainContainer>
  )
}
